import React, { useState } from "react"
import { graphql } from "gatsby"
import { getStringFromElement, stringToSlug } from "../utils/gatsby-helpers"
import rehypeRaw from "rehype-raw"
import ReactMarkdown from "react-markdown"
import Seo from "../components/seo"
import NewLayout from "../components/new_layout"

const ContractingConditions = ({ data, pageContext }) => {
    const page = data.page.edges[0].node

    let indexItems = []

    if (typeof window !== `undefined` && typeof document !== `undefined`) {
        const e = document.createElement("div")
        const o = document.createElement("div")

        e.innerHTML = page.description_one

        e.querySelectorAll("h3").forEach((element, index) => {
            indexItems.push(element.innerText)
        })

        o.innerHTML = page.description_two

        o.querySelectorAll("h3").forEach((element, index) => {
            indexItems.push(element.innerText)
        })
    }

    const elements = {
        h3: ({ node, ...props }) => {
            const element = <h2 {...props} />
            const stringElement = getStringFromElement(element)

            return <h3 id={"item-" + stringToSlug(stringElement)} {...props} />
        },
    }

    return (
        <NewLayout pageContext={pageContext}>
            <Seo lang={pageContext.langKey} title={page.seo.title} description={page.seo.meta_description} translates={pageContext.translates} />

            <main className="main">
                <div className="main__section main__section--20-80">
                    <div className="container">
                        <div className="hidden-lg">
                            <div className="container__index">
                                {indexItems.map((item, index) => {
                                    const slug = "#item-" + stringToSlug(item)
                                    return   <a href={`#${stringToSlug(slug)}`}>{item}</a>
                                })}
                            </div>
                        </div>
                        <div className="container__text">
                            <h1 className="hero">{page.title}</h1>
                            <div className="container__text__text">
                                <ReactMarkdown children={page.description_one} rehypePlugins={[rehypeRaw]} components={elements} />
                                <div className="list-table">
                                    {page.items.map((item, index) => (
                                        <div key={index} className="list-table__item">
                                            <h6>{item.title}</h6>
                                            <ReactMarkdown children={item.description} rehypePlugins={[rehypeRaw]} />
                                        </div>
                                    ))}
                                </div>
                                <ReactMarkdown children={page.description_two} rehypePlugins={[rehypeRaw]} components={elements} />
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </NewLayout>
    )
}

export default ContractingConditions;

export const contractingConditionsPageQuery = graphql`
query($langKey: String) {
    page: allStrapiLegalCondicionesGeneralesDeContratacion (
        filter: { locale: { eq: $langKey } }
    ) {
        edges {
            node {
                id,
                seo {
                    title,
                    meta_description
                }
                title
                description_one
                items {
                    order
                    title
                    description
                }
                description_two
            }
        }
    }
}`;
